import { tenderAIAPi } from './tender-ai-api';
const initiateChat = (id) => {
    const obj = { ProposalId: id };
    return tenderAIAPi.post(`chat/ChatInitiate`, obj);
};
const sendMessage = (message) => {
    return tenderAIAPi.post(`chat/SendMessage`, message);
};
const getChatHistory = (ProposalId) => {
    return tenderAIAPi.get(`chat/${ProposalId}/GetChatHistory`);
};
const downloadDocument = (request) => {
    return tenderAIAPi.post(`chat/DownloadDocument`, request);
};
const cleanChat = (cleanRequest) => {
    return tenderAIAPi.post(`chat/CleanChat`, cleanRequest);
};
const downloadChat = (chatDownloadRequest) => {
    return tenderAIAPi.post(`chat/DownloadChat`, chatDownloadRequest);
};
const ChatApi = {
    initiateChat,
    sendMessage,
    getChatHistory,
    cleanChat,
    downloadChat,
    downloadDocument
};
export default ChatApi;
